<template>
  <div id="page-selects">
    <v-container grid-list-xl fluid>
      <breadcrumbs
        :routelinks="[
          { text: 'Historical List Student', href: '#/historical-students' },
          { text: 'View', href: '#', disabled: true }
        ]"
      />
      <v-layout row wrap class="pa-3">
        <v-flex lg8 md8 xs12 class="elevation-2 white pa-3">
          <div v-show="true">
            <submit-form v-if="isVisible === 0" @edit="isVisible = 1" />
            <submit-form-edit v-if="isVisible === 1" />
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import Breadcrumbs from "@/components/Breadcrumbs";
import SubmitForm from "@/components/HistoricalList/studentsList/SubmitForm";
import SubmitFormEdit from "@/components/HistoricalList/studentsList/SubmitFormEdit";
export default {
  components: {
    Breadcrumbs,
    SubmitForm,
    SubmitFormEdit
  },
  data() {
    return {
      isVisible: 0
    };
  },
  computed: {},
  watch: {},
  methods: {
    listChanged: function(index) {
      this.isVisible = index;
    }
  }
};
</script>
